module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-course-eebe2157022e9adf0073c70bfe8bd9de.png";